<template>
  <div>
    <signature-layout
      :submitSignature="sign"
      :signatureId="signatureId"
      :isLoading="isLoading"
      :foundRequest="found"
      :errorMessage="errorMessage"
      :workflowGuid="registration.workflowGuid"
      :submittedAt="registration.submittedAt"
    >
      <span slot="subtitle"> Registration Application </span>
      <span slot="title"
        >Litter whelped on
        <span
          :class="registration.isWhelpingDateConflicting ? 'red--text' : ''"
        >
          <localized-date :date="registration.whelpingDate" />
        </span>
      </span>
      <div slot="approvedContent" v-if="registration && registration.puppies">
        <litter-registration-request :registration="registration">
        </litter-registration-request>
      </div>
      <div slot="legalText">
        <p class="bottom-text">
          Upon signing, I testify that all data submitted is correct. I
          understand that all applications become the property of ASCA.
        </p>
        <p>
          I further certify that I was the owner, co-owner, or lessee of the
          sire(s) listed on this application on the date of birth of the litter
          and that this dam was mated only to the sire listed on this
          application.
        </p>
        <p>
          Should information in this application prove false, applicant will
          indemnify and defend ASCA and hold it harmless against any resulting
          loss. The lineage of your dog can be determined with certainty by DNA
          testing sponsored by ASCA.
        </p>
        <p>
          I further understand that as an owner of an ASCA registered litter, I
          agree to abide by the <ASCAArtIncLink />, <BylawsLink />, and all ASCA
          Rules and Regulations governing the ASCA Registry, Conformation,
          Obedience and Stock Dog Program and to disciplinary action, if
          necessary, as determined by the ASCA Board of Directors.
        </p>
        <p>
          I hereby certify these dogs have not been registered as another breed.
          In addition, I will not register these dogs as another breed. I
          understand if I register these dogs as another breed, their ASCA
          registration will be revoked.
        </p>
      </div>
    </signature-layout>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import SignatureLayout from "@/components/common/SignatureLayout.vue";
import LitterRegistrationRequest from "@/components/Portal/MyRequest/LitterRegistrationRequest.vue";
import ASCAArtIncLink from "@/components/common/ASCAArtIncLink.vue";
import BylawsLink from "@/components/common/BylawsLink.vue";

import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";
import { getErrorMessage } from "@/services/errorHandler";

export default Vue.extend({
  name: "LitterRegistrationSignatureForm",
  components: {
    SignatureLayout,
    LitterRegistrationRequest,
    ASCAArtIncLink,
    BylawsLink,
  },
  props: { signatureId: Number },
  data: function () {
    return {
      signatureText: "",
      errorMessage: "",
      registration: Object,
      isLoading: false,
      found: false,
    };
  },
  created() {
    this.load();
  },
  watch: {
    signatureId: function (newValue) { this.load(); }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    load: async function () {
      this.isLoading = true;
      this.errorMessage = "";
      this.found = false;

      try {
        const response = await workflowService.getLitterRegistrationDetailsForSignature(this.signatureId);
        this.found = response.found;

        if (response.found && (!response.errors || response.errors.length == 0)) {
          this.registration = response.data;
        } else if (!!response.errors) this.errorMessage = response.errors ? response.errors.join(',') : 'An Unknown Error Occured'
      } catch (error) {
        this.errorMessage = getErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    sign: function (workflowGuid: String, signatureId: number, text: String) {
      workflowService
        .signLitterRegistration(workflowGuid, signatureId, text)
        .then((res) => {
          this.$store.dispatch("loadPersonTasks");
          this.$navigate("/");
        }).catch(this.$handleError);
    },
  },
});
</script>
